import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { fetchIsInProgramme } from "../../redux/actions/preferred-programs";
import { token } from "../../modules/auth";
import ReactTooltip from "react-tooltip";
import { checkVenueForPreferredProgramme } from "../../services/hotelGroupService/preferredProgrammesService";
import { checkVenuesForCommercialDeals } from "../../services/commercialDealService/commercialDeals";
const Badge = ({ text, title, type, className, token, venueId }) => {

  return (
    <div
      data-tip
      data-for={venueId + '_cdbadge'}
      data-event="click"
      className={
        className ??
        "rounded-sm bg-gold py-1 px-2 text-white text-sm font-normal mr-2 text-center cursor-pointer uppercase"
      }
    >
      {text}
    </div>
  );
};

const ToolTip = ({ availableDeals }) => {
  if(availableDeals) {
    return (  <div
      className="text-transform-none"
      style={{ zIndex: "999999" }}
    >
      {availableDeals.map(deal => {
        if(deal.percentage) {
          return <div><strong>{deal.name}</strong>: <span>{deal.percentage}%</span></div>
        }
      }) }
    </div>)


  }


}

let CommercialDealBadge = ({
                                 venue,
                                 venueId,
                                 hasCommercialDeal,
                                 text,
                                 className,
                                 singleButton = false,
                                 token,
                                 small = false
                               }) => {
  let id = venue ? venue.id : venueId
  if (!hasCommercialDeal || hasCommercialDeal.length === 0) return null;
  if(hasCommercialDeal && typeof hasCommercialDeal[id] === 'undefined') return null;
  let availableDeals = Object.values(hasCommercialDeal[id])
  let maxPercent =  Object.values(hasCommercialDeal[id]).length > 1 ? Object.values(hasCommercialDeal[id]).reduce(function(prev, current) {
    return (prev && prev.percentage > current.percentage) ? prev : current
  }).percentage : Object.values(hasCommercialDeal[id]).find(x=>x!==undefined).percentage //returns object
  return (
    <div>
      <Badge
        title={"Commercial Deal"}
        text={text ? text : small ?`${maxPercent}%` : `Commission / Deal ${Object.values(hasCommercialDeal[id]).length > 1 ? 'up to' : ''} ${maxPercent}%`}
        className={className }
        venueId={id}
        token={token}
      />
      {availableDeals  ?
        <ReactTooltip
          id={id + '_cdbadge'}
          effect="solid"
          type="light"
          clickable={true}
          className="tooltip-shadow"
          globalEventOff="click"
        >
         <ToolTip availableDeals={availableDeals}/>
        </ReactTooltip> : null}
    </div>
  );
};

export default withRouter(
  connect(
    (state, props) => {
      return {
        token: token(state),
      };
    },
    { fetchIsInProgramme },
  )(CommercialDealBadge),
);
